import Occurrence from '../models/Occurrence';
import Event from '../models/Event';
import TagOptions from '../models/TagOptions';
import QueryString from 'designmynight-javascript-sdk/src/Http/QueryString.js';
import moment from 'moment-timezone';

class DataProviderService {

    dmnOptions: any|TagOptions;
    dmnResources: any;
    selectedEvent: Event|any;

    constructor(dmnOptions?: TagOptions, dmnResources?: any) {
        this.dmnOptions = dmnOptions;
        this.dmnResources = dmnResources;
    }

    /**
    * @desc sends the API request for the event data.
    * @param {string} itemIds
    */
    getEventsData(itemIds: string) {
        let params: any = {};

        // add the occurrence
        if(this.dmnOptions.occurrence) {
            params.occurrence = this.dmnOptions.occurrence;
        }

        // if no occurrence but there is a presale code, just add the presale code
        if(this.dmnOptions.presaleCode) {
            params.presale_code = this.dmnOptions.presaleCode;
        }

        const queryString = new QueryString(params);
        let path: string = queryString.stringify();

        // add the itemIds to the start of the path. This is added seperate as there can be multiple itemIds's in one string
        path = path ? itemIds + path : itemIds;

        return this.dmnResources.ticketWidget().get(path).then(
            (data:any) => data
        );
    }

    /**
    * @desc uses SDK to make an API request for the occurrence dates passed through or checks if the occurrences are in the cache
    * @param {moment} occurrenceFrom
    * @param {moment} occurrenceTo
    */
    getOccurrenceData(occurrenceFrom: moment.Moment, occurrenceTo: moment.Moment) {
        let formattedFrom = occurrenceFrom ? occurrenceFrom.format('YYYY-MM-DD') : null;
        let formattedTo = occurrenceTo ? occurrenceTo.format('YYYY-MM-DD') : null;

        let params: any = {
            events_from: formattedFrom,
        };

        if(formattedTo) {
            params.events_to = formattedTo;
        }

        const queryString = new QueryString(params);
        let path: string = queryString.stringify();

        return this.dmnResources.ticketWidget().get(this.selectedEvent._id + '/occurrences' + path).then(
            (data:any) => {
                let occurrenceData: any = {
                    occurrences: {},
                    serverTime: ''
                };

                for(let key in data.occurrences) {
                    occurrenceData.occurrences[key] = new Occurrence(this.selectedEvent._id, key, data.occurrences[key]);
                    occurrenceData.occurrences[key].serverTime = data.serverTime;
                    occurrenceData.serverTime = moment(data.serverTime);
                }

                return occurrenceData;
            }
        );
    }

    getLinkedOccurrenceData(eventId: string, pageStart: moment.Moment, pageEnd?: moment.Moment) {
        let params: any = {
            item_id: eventId,
            item_date_from: pageStart.format('YYYY-MM-DD'),
        };
        if(pageEnd){
            //Add a buffer of 1 month to the event
            params.item_date_to = pageEnd.clone().add(1,'month').format('YYYY-MM-DD');
        }

        const queryString = new QueryString(params);
        let path: string = queryString.stringify();

        return this.dmnResources.linkedOccurrences().get(path).then((data: any) => data);
    }

    getPromotionData(eventId: string, occurrenceDate: any) {
        let path = '/' + eventId + '/occurrences/' + occurrenceDate + '/promotions';

        return this.dmnResources.tonicPromotions().get(path).then(
            (data:any) => data.data
        );
    }
}

export default DataProviderService;
